import ContractRowModel from "../models/ContractRowModel";
import MeasurementRowModel from "../models/MeasurementRowModel";
import WBSModel from "../models/WBSModel";
import CalculateMeasurementRowService from "./CalculateMeasurementRowService";

class MeasurementRowListService {
  addRowToList(
    rowsList: WBSModel<MeasurementRowModel>,
    contractRow: ContractRowModel
  ): MeasurementRowModel {
    const newMeasurement = MeasurementRowModel.createBlank(contractRow.uid, {
      measurementUid: rowsList.uid,
      contractUid: contractRow.contractUid,
      structured: contractRow.structured,
      rowType: contractRow.rowType,
    });

    newMeasurement.attachContractRow(contractRow);
    CalculateMeasurementRowService.calculateMeasurementValues(
      newMeasurement,
      newMeasurement.currentMeasurement
    );

    rowsList.addRowList([newMeasurement]);
    return newMeasurement;
  }

  subtractValuesFromContractRow(rows: MeasurementRowModel[]) {
    for (const row of rows) {
      const contract = row.contractRow;
      if (contract) {
        contract.removeMeasuredOf(row.measurementUid);
      }
    }
  }

  getRowFromList(
    rowsList: WBSModel<MeasurementRowModel>,
    contractRow: ContractRowModel
  ): MeasurementRowModel | undefined {
    if (!rowsList || !contractRow) return;

    const measurement = rowsList.getRowByUid(contractRow.uid);
    if (measurement && !measurement.contractRow) {
      measurement.attachContractRow(contractRow);
      CalculateMeasurementRowService.calculateMeasurementValues(
        measurement,
        measurement.currentMeasurement
      );
    }
    return measurement;
  }
}

export default new MeasurementRowListService();
